var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tui-datepicker-input tui-datetime-input tui-has-focus"},[_c('input',{ref:"input",attrs:{"type":"text","id":_vm.id,"aria-label":"Date-Time","readonly":""}}),_vm._v(" "),_c('div',{staticClass:"tui-datepicker_calendar",style:(_vm.wrapperStyle),attrs:{"id":_vm.tuiDatepickerContainerId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }